export default (banner, itemKey) => {
	if ((itemKey + 1) % 4 === 0) {
		return `<a class="banner banner--schedule" href="${banner.getAttribute('href')}" target="_blank">
          <img class="banner__img" src="${banner.firstElementChild.getAttribute('src')}"/>
        </a>`
	}
	return null
}
